import { create } from 'zustand'
import type { SensorPlacement } from '@/features/ble/types'

export interface SensorTelemetry {
  position: { x: number; y: number; z: number }
  rollPitchYaw: { roll: number; pitch: number; yaw: number }
  angleToPreviousLinkDeg: number
  angleToHorizontalDeg: number
}

interface TelemetryStoreState {
  telemetry: Partial<Record<SensorPlacement, SensorTelemetry>>
  setTelemetry: (placement: SensorPlacement, telemetry: SensorTelemetry) => void
  clearTelemetry: (placement: SensorPlacement) => void
  clearAllTelemetry: () => void
}

/**
 * Live telemetry for tracked sensors, published (throttled) by SkeletonModel
 * and consumed by the sensor info panel.
 */
export const useTelemetryStore = create<TelemetryStoreState>((set) => ({
  telemetry: {},
  setTelemetry: (placement, telemetry) =>
    set((state) => ({ telemetry: { ...state.telemetry, [placement]: telemetry } })),
  clearTelemetry: (placement) =>
    set((state) => {
      const telemetry = { ...state.telemetry }
      delete telemetry[placement]
      return { telemetry }
    }),
  clearAllTelemetry: () => set({ telemetry: {} }),
}))
